// Generated by Melange

import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

const loadingDiv = "flex h-full w-full items-center justify-center";

const Styles = {
  loadingDiv: loadingDiv
};

function LoadingDiv(Props) {
  let sizeOpt = Props.size;
  let borderWidthOpt = Props.borderWidth;
  let primaryColorOpt = Props.primaryColor;
  let secondaryColorOpt = Props.secondaryColor;
  let className = Props.className;
  const size = sizeOpt !== undefined ? sizeOpt : "w-9 h-9";
  const borderWidth = borderWidthOpt !== undefined ? borderWidthOpt : "border-4";
  const primaryColor = primaryColorOpt !== undefined ? primaryColorOpt : "border-links";
  const secondaryColor = secondaryColorOpt !== undefined ? secondaryColorOpt : "border-t-default-gray";
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      className: Cn.fromList({
        hd: "animate-spin rounded-full",
        tl: {
          hd: size,
          tl: {
            hd: borderWidth,
            tl: {
              hd: primaryColor,
              tl: {
                hd: secondaryColor,
                tl: /* [] */ 0
              }
            }
          }
        }
      })
    }),
    className: Cn.fromList({
      hd: loadingDiv,
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    })
  });
}

const make = LoadingDiv;

export {
  Styles,
  make,
}
/* react/jsx-runtime Not a pure module */
